// Textos del listado y la edición de usuarios WAIIS (user-list). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'es',
  data: {
    WAIIS_USER_LIST: {
      EXPORT_CSV: 'Exportar CSV',
      KPIS: {
        ARIA: 'Indicadores de usuarios',
        TOTAL: 'Usuarios totales',
        TOTAL_HINT: 'Cuentas dadas de alta en la app',
        NEW_7D: '+{{count}} en los últimos 7 días',
        ACTIVE_30D: 'Activos (30 días)',
        ACTIVE_30D_HINT: 'Han abierto la app en el último mes',
        DRIVERS: 'Conductores',
        DRIVERS_HINT: 'Con vehículo dado de alta',
        BANNED: 'Bloqueados',
        BANNED_HINT: 'Cuentas bloqueadas por el equipo',
        SHARE_OF_TOTAL: '{{pct}} del total',
        IN_TABLE: 'En la tabla',
        SEE_IN_TABLE: 'Ver en la tabla',
      },
      FILTERS: {
        SEARCH_PLACEHOLDER: 'Buscar nombre, email, teléfono o ID…',
        SEARCH_ARIA: 'Buscar usuario',
        TYPE_ARIA: 'Tipo',
        STATUS_ARIA: 'Estado',
        ACTIVITY_ARIA: 'Actividad',
        CLEAR: 'Limpiar filtros',
        TYPE: {
          ALL: 'Tipo: todos',
          DRIVER: 'Conductores',
          NO_DRIVER: 'Sin vehículo',
          ADMIN: 'Administradores',
        },
        STATUS: {
          ALL: 'Estado: todos',
          NOT_BANNED: 'No bloqueados',
          BANNED: 'Bloqueados',
        },
        ACTIVITY: {
          ALL: 'Actividad: cualquiera',
          TODAY: 'Hoy',
          LAST_7D: 'Últimos 7 días',
          LAST_30D: 'Últimos 30 días',
          INACTIVE_30D: 'Sin actividad en 30 días',
        },
      },
      PANEL: {
        TITLE_DRIVERS: 'Conductores',
        TITLE_DRIVERS_BANNED: 'Conductores bloqueados',
        TITLE_NO_DRIVER: 'Usuarios sin vehículo',
        TITLE_ADMINS: 'Administradores',
        TITLE_BANNED: 'Usuarios bloqueados',
        TITLE_ACTIVE_30D: 'Usuarios activos (30 días)',
        TITLE_ALL: 'Usuarios registrados',
        PART_ACTIVITY: 'actividad: {{value}}',
        PART_SEARCH: 'búsqueda «{{value}}»',
        SUB_FILTERED: 'Filtrado por {{filters}}. Pulsa una fila para abrir su ficha.',
        SUB_ALL: 'Todas las cuentas dadas de alta en la app. Pulsa una fila para abrir su ficha.',
      },
      TABLE: {
        LOADING: 'Cargando…',
        LOADING_USERS: 'Cargando usuarios',
        COL_CREATED: 'Alta',
        COL_USER: 'Usuario',
        COL_PHONE: 'Teléfono',
        COL_ROLE: 'Rol',
        COL_VERIFICATION: 'Verificación',
        COL_LAST_ACTIVITY: 'Última actividad',
        COL_STATUS: 'Estado',
        COL_OPEN: 'Abrir',
        VIEW_PROFILE: 'Ver ficha',
        RETRY: 'Reintentar',
        EMPTY_FILTERED: 'Ningún usuario coincide con la búsqueda.',
        EMPTY: 'Todavía no hay usuarios.',
        NO_ACTIVITY_RECORDED: 'Sin actividad registrada',
        NO_NAME: 'Sin nombre',
      },
      ERRORS: {
        INVALID_FILTER: 'Algún filtro no es válido. Prueba a limpiar los filtros.',
        LOAD: 'No se ha podido cargar el listado de usuarios.',
      },
      PAGINATION: {
        SHOWING_ONE: 'Mostrando {{shown}} de {{total}} usuario',
        SHOWING_OTHER: 'Mostrando {{shown}} de {{total}} usuarios',
        PREV: 'Anterior',
        NEXT: 'Siguiente',
        PREV_ARIA: 'Página anterior',
        NEXT_ARIA: 'Página siguiente',
        PER_PAGE: '{{count}} por página',
        PER_PAGE_ARIA: 'Usuarios por página',
      },
      ROLE: {
        ADMIN: 'Admin',
        BUSINESS: 'Empresa',
        APP: 'App',
      },
      STATUS: {
        BANNED: 'Bloqueado',
        ACTIVE: 'Activo',
      },
      CHECKS: {
        PHONE_ON: 'Teléfono verificado',
        PHONE_OFF: 'Teléfono sin verificar',
        DOCUMENT_ON: 'Documento verificado',
        DOCUMENT_OFF: 'Documento sin verificar',
        LICENSE_ON: 'Carnet verificado',
        LICENSE_OFF: 'Carnet sin verificar',
      },
      AGO: {
        NEVER: 'Nunca',
        NOW: 'Ahora',
        MINUTES: 'Hace {{count}} min',
        HOURS: 'Hace {{count}} h',
        YESTERDAY: 'Ayer',
        DAYS: 'Hace {{count}} días',
        MONTHS_ONE: 'Hace 1 mes',
        MONTHS_OTHER: 'Hace {{count}} meses',
        OVER_YEAR: 'Hace más de un año',
      },
    },
    USER_EDIT: {
      TITLE: 'Editar usuario',
      SUBTITLE: 'Datos de la cuenta del usuario.',
      SUBTITLE_WHO: 'Datos de la cuenta de {{name}}.',
      BACK: 'Volver a la ficha',
      LOADING: 'Cargando el usuario',
      CANCEL: 'Cancelar',
      SAVE: 'Guardar cambios',
      SAVING: 'Guardando…',
      SECTIONS: {
        PERSONAL: 'Datos personales',
        PERSONAL_SUB: 'Nombre y datos básicos de la persona.',
        CONTACT: 'Contacto y cuenta',
        CONTACT_SUB: 'Cómo se identifica en la app y en qué idioma la usa.',
        DOCUMENT: 'Documento',
        DOCUMENT_SUB: 'Documento de identidad y CAE.',
        PROFESSIONAL: 'Perfil profesional',
        PROFESSIONAL_SUB: 'Lo que ven otras personas de la comunidad.',
        PREFERENCES: 'Preferencias',
        PREFERENCES_SUB: 'Suscripciones y estado de la cuenta.',
      },
      FIELDS: {
        NAME: 'Nombre',
        SURNAME: 'Apellido',
        GENDER: 'Género',
        BIRTH_DATE: 'Fecha de nacimiento',
        EMAIL: 'Email',
        PHONE: 'Teléfono',
        ROLE: 'Rol',
        LANGUAGE: 'Idioma',
        DOCUMENT_TYPE: 'Tipo de documento',
        DOCUMENT: 'Documento',
        CAE: 'CAE',
        PROFESSION: 'Profesión',
        RELATED_COMPANY: 'Empresa relacionada',
        LINKEDIN: 'URL LinkedIn',
        DESCRIPTION: 'Descripción',
        SUBSCRIBE: 'Suscribirse',
        NEWSLETTER: 'Suscrito al newsletter',
        AVAILABLE: 'Disponible',
        VIRTUAL: 'Virtual',
      },
      SELECT: {
        ROLE: 'Selecciona un rol',
        LANGUAGE: 'Selecciona un idioma',
        GENDER: 'Selecciona un género',
        DOCUMENT_TYPE: 'Selecciona un tipo',
      },
      ROLES: {
        DRIVER_PARTICULAR: 'Conductor Particular',
        DRIVER_COMPANY: 'Conductor Empresa',
        ADMIN: 'Administrador',
        LOGISTICS: 'Logística',
      },
      GENDERS: {
        M: 'Masculino',
        F: 'Femenino',
        O: 'Otro',
      },
      DOCUMENT_TYPES: {
        DNI: 'DNI',
        NIE: 'NIE',
        PASSPORT: 'Pasaporte',
      },
      ERRORS: {
        REQUIRED: '{{field}} es requerido',
        MIN_LENGTH: '{{field}} debe tener mínimo {{min}} caracteres',
        EMAIL: 'Ingresa un email válido',
        PATTERN: '{{field}} tiene un formato inválido',
        INVALID: 'Campo inválido',
        ROLE_REQUIRED: 'El rol es requerido',
        LANGUAGE_REQUIRED: 'El idioma es requerido',
      },
      SWAL: {
        SUCCESS_TITLE: 'Usuario actualizado',
        SUCCESS_TEXT: 'Los cambios se han guardado correctamente.',
        ERROR_TITLE: 'No se han podido guardar los cambios',
        LOAD_DATA_ERROR: 'Error al cargar los datos del usuario',
        LOAD_ERROR: 'Error al cargar el usuario',
        UPDATE_ERROR: 'Error al actualizar el usuario',
      },
    },
  },
};
